export default "__VITE_ASSET__BCe78Ixs__"